(function () {
    'use strict';

    angular
        .module('app')
        .directive('journeyNav', journeyNav);

    journeyNav.$inject = ['$window'];

    function journeyNav($window) {
        // Usage:
        //     <navigationTakeover></navigationTakeover>
        // Creates:
        // 
        var directive = {
            link: link,
            restrict: 'EA'
        };
        return directive;

        function link(scope, element, attrs) {
            // Get a reference to the <path>
            var path = document.querySelector('#line-path');

            // Get length of path... ~577px in this case
            var pathLength = path.getTotalLength();

            // Make very long dashes (the length of the path itself)
            path.style.strokeDasharray = pathLength + ' ' + pathLength;

            // Offset the dashes so the it appears hidden entirely
            path.style.strokeDashoffset = pathLength;

            // Jake Archibald says so
            // https://jakearchibald.com/2013/animated-line-drawing-svg/
            path.getBoundingClientRect();

            // When the page scrolls...
            window.addEventListener("scroll",
                function (e) {

                    // What % down is it? 
                    // https://stackoverflow.com/questions/2387136/cross-browser-method-to-determine-vertical-scroll-percentage-in-javascript/2387222#2387222
                    // Had to try three or four differnet methods here. Kind of a cross-browser nightmare.
                    var scrollPercentage = (document.documentElement.scrollTop + document.body.scrollTop) /
                        (document.documentElement.scrollHeight - document.documentElement.clientHeight);

                    // Length to offset the dashes
                    var drawLength = pathLength * scrollPercentage;

                    // Draw in reverse
                    path.style.strokeDashoffset = pathLength - drawLength;

                    // When complete, remove the dash array, otherwise shape isn't quite sharp
                    // Accounts for fuzzy math
                    if (scrollPercentage >= 0.99) {
                        path.style.strokeDasharray = "none";

                    } else {
                        path.style.strokeDasharray = pathLength + 200 + ' ' + pathLength;
                    }

                });

            function removeMenuBubbleInlineCss() {
                //revert size of bubble to original
                var menuBubble = $(".menu-bubble-open");
                menuBubble.css('height', '');
                menuBubble.css('width', '');
            }

            function closeBubble() {
                $(".full-list .inner-bubble").removeClass('show').addClass('hide');
                $("#menu-bubble").removeClass('menu-bubble-open').addClass('closed');
                $('.full-list li:first').removeClass('reposition');  
            }

            (function ($) {
                $(document).ready(function () {

                    if ($(window).width() <= 4000) {
                        $('div#menu-bubble').on('click',
                            function (e) {
                                e.stopPropagation();
                                $(this).addClass('menu-bubble-open');

                                $(".full-list .inner-bubble").addClass('show').removeClass('hide');
                                $('.full-list li:first').addClass('reposition');

                                //calculate size of bubble according to # of content
                                var fullListDiv = $(this).find('ul.full-list');
                                var size = fullListDiv.outerHeight(true) + 15;
                                $(this).height(size);
                                $(this).width(size); 
                                
                            });

                        $('li#bubble-close').on('click',
                            function (e) {
                                e.stopPropagation();
                                removeMenuBubbleInlineCss();

                                $("#menu-bubble").removeClass('menu-bubble-open').addClass('closed');
                                $('.full-list li:first').removeClass('reposition');
                                $(".full-list .inner-bubble").addClass('hide').removeClass('show');

                                // $(".full-list .inner-bubble").addClass('hide').removeClass('show');
                            });

                        $('li.inner-bubble a').on('click',
                            function() {                                
                                window.location = $(this).attr('href');
                            });
                    }
                    $(window).scroll(function () {
                        removeMenuBubbleInlineCss();

                        closeBubble();

                        if ($(this).scrollTop() > 500) {
                            $('#menu-bubble').fadeIn(500);

                            // $('.pop_up').fadeIn(500);
                        } else {
                            $('#menu-bubble').fadeOut(100);
                            $('.pop_up').removeClass('show-popup');
                            // $('.pop_up').fadeOut(500);
                        }
                    });

                    $(window).click(function () { 
                        removeMenuBubbleInlineCss();
                        closeBubble();                        
                    });
                    
                });

                $('div#menu-bubble').click(function (event) {
                    event.preventDefault();
                    $('.pop_up').toggleClass('show-popup');

                });

            })(jQuery);
        }
    }
})();


//////////////////
// WEBPACK FOOTER
// ./Views/Shared/Partials/JourneyHeader/_journeyNav.js
// module id = 30
// module chunks = 0